import React from 'react'
import { AllRoutes } from './AllRoutes'
import styled from "styled-components"


export const Main = () => {
  return (
    <DIV>
      
      <div style={{ width: "90%", margin: "auto" }}>
        <AllRoutes />
      </div>


    </DIV>
  )
}

const DIV = styled.div`

    
`
